// Browser/platform detection helpers.
//
// Keep these narrow and well-justified — user-agent sniffing is a last resort,
// used only where a real, browser-specific engine limitation forces a different
// code path (not for styling or feature-detection, which belong in CSS/feature
// checks).

/**
 * True for Apple/WebKit browsers: desktop Safari and every iOS browser (iOS
 * Chrome/Firefox are WebKit under the hood, sharing the same engine).
 *
 * Why we care: WebKit handles a long-lived streamed `fetch()` response (our SSE
 * course-creation stream) unreliably — it can deliver no body bytes and then
 * drop the connection with "The network connection was lost" (kCFURLError
 * -1005), especially through a buffering proxy like Cloud Run. Chromium/Gecko
 * consume the same stream fine. Callers use this to fall back to a
 * non-streaming request + status polling on WebKit.
 */
export function isAppleWebkit() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';

  // All iOS browsers use WebKit regardless of brand.
  const isIOS =
    /iP(hone|od|ad)/.test(ua) ||
    // iPadOS 13+ Safari reports a Mac UA; disambiguate via touch support.
    (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1);

  // Desktop Safari: has "Safari/" but is not Chromium/Chrome/Edge/Firefox.
  const isDesktopSafari =
    /Safari\//.test(ua) && !/Chrom(e|ium)|CriOS|FxiOS|Edg\//.test(ua);

  return isIOS || isDesktopSafari;
}
